// extracted by mini-css-extract-plugin
export default {"container":"TopTabs_container__Ge2Ce","tabIndicator":"TopTabs_tabIndicator__eRZ9S","tabs":"TopTabs_tabs__upO64","tab":"TopTabs_tab__nbkeC"};